import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import EnvironmentManager from '../../../../utils/environmentManager';
import Icon from '../../Icon';
import BetPill from '../../Pills/BetPill';
import { addEventVerifyRecommended, removeEventFromBetSlip } from '../../../store/actions';
import { useDispatch } from 'react-redux';
import { generateSportTypeIcons } from '../../../../utils/generateSportTypeIcons';

const TribunRouteRecommendedModal = ({
  onSecondaryButtonClick,
  couponDetails,
  playCouponState,
  data
})  => {
  const dispatch = useDispatch();
  const disclamerMsg = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_disclamer_message' });
  const avatar = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_avatar' });
  const commentHeader = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_comment_header' });
  const commentTextMain = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_comment_text_main' });
  const titleRow1 = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_row_1' });
  const titleRow2 = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_row_2' });
  const commentTextMainArr = commentTextMain.split('%@');
  const titleRow1Arr = titleRow1.split('%@');
  const titleRow2Arr = titleRow2.split('%@');

  const { totalCost, probability, mbs, sportId, matchDateDisplay, eventId, eventName, playedCouponDetail, recommendedCouponDetail } = playCouponState?.recommendedData;
  const { name } = data?.auth?.data;
  
  const events = {
    eventId: eventId,
    marketId: recommendedCouponDetail?.marketId,
    marketOutcomeNo: recommendedCouponDetail?.marketOutcomeId
  };
  const oddId = `${events.eventId}:${events.marketId}:${events.marketOutcomeNo}`;

  const isSelected = couponDetails.some(coupon => {
    return coupon.bets[0].id === oddId;
  });

  const toggleAction = () => {
    !isSelected
      ? dispatch(addEventVerifyRecommended({ eventId, event: recommendedCouponDetail, recommendedCost: recommendedCouponDetail?.cost  }))
      : dispatch(removeEventFromBetSlip(oddId));
  };

  const professionIcons = generateSportTypeIcons;

  return (
    <div className="play-coupon-success-modal">
      <>
        {
          <div className="wrapper">
            <div className='page--recommended-detail__author'>
              <div className="wrapper">
                <div className="recommended__row--detail" style={ { background: '#EDEDED', } }>
                  <div className="recommended__row__img">
                    <img className="recommended__row__img__avatar"
                      src={ avatar }
                      alt={ avatar }/>
                  </div>

                  <div className="recommended__row__text">
                    <span className="recommended__row__title"> { commentHeader } </span>
                  </div>
                </div>
                <div className="recommended-comments__row">
                  <div className="recommended-comments__row__comment">
                    <div className="recommended-comments__row__detail">
                      <b>{ playedCouponDetail?.label }</b> { commentTextMainArr[1] }
                      <b>{ recommendedCouponDetail?.label }</b> { commentTextMainArr[2] }
                      <b>% { Math.round(playedCouponDetail?.probability * 100) }</b>
                      { commentTextMainArr[3] }
                      <b>% { Math.round(probability * 100) }</b> { commentTextMainArr[4] }
                    </div>

                    <div className="recommended-comments__row__commentDesc">
                      <div style={ { overflowX: 'auto', height: '150px' } }>
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th/>
                              <th
                                dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_column_1' }) } }/>
                              <th
                                dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_column_2' }) } }/>
                              <th
                                dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_column_3' }) } }/>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                dangerouslySetInnerHTML={ { __html: `${titleRow1Arr[0]}${playedCouponDetail?.label || ''}${titleRow1Arr[1]}`.replace(/<br\s*\/?>/gi, '') } }/>
                              <td>{ playedCouponDetail?.cost } TL</td>
                              <td>{ playedCouponDetail?.expectedWinAmount.toFixed() } TL</td>
                              <td>% { Math.round(playedCouponDetail?.probability * 100) }</td>
                            </tr>
                            <tr>
                              <td
                                dangerouslySetInnerHTML={ { __html: `${titleRow2Arr[0]}${recommendedCouponDetail?.label || ''}${titleRow2Arr[1]}`.replace(/<br\s*\/?>/gi, '') } }
                              />
                              <td>{ recommendedCouponDetail?.cost } TL</td>
                              <td>{ recommendedCouponDetail?.expectedWinAmount.toFixed() } TL</td>
                              <td>% { Math.round(recommendedCouponDetail?.probability * 100) }</td>
                            </tr>
                            <tr className="highlight-row">
                              <td
                                dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_row_3' }).replace(/<br\s*\/?>/gi, '') } }/>
                              <td>{ totalCost } TL</td>
                              <td>{ playedCouponDetail?.expectedWinAmount.toFixed() } TL
                              - { recommendedCouponDetail?.expectedWinAmount.toFixed() } TL
                              </td>
                              <td>% { Math.round(probability * 100) }</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="recommended-comments__row__event">
                    <div className="recommended-comments__row__detail">
                      <img
                        className="recommended__row__leagues__profession"
                        src={ professionIcons(sportId) }
                      />{ eventName }
                    </div>
                  </div>
                  <div className="recommended-comments__row__pills">
                    <div className="recommended-comments__row__pills-title">{ recommendedCouponDetail?.marketName }</div>
                    <div className="recommended-comments__row__pills-pill">
                      <Icon iconName={ mbs > 4 ? 'iconMbs4Betslip' : `iconMbs${mbs}Betslip` }/>
                      <BetPill
                        pillStyle="horizontal"
                        odd={ recommendedCouponDetail?.fixedOddsWeb }
                        betType={ recommendedCouponDetail?.label || recommendedCouponDetail?.marketOutcomeName }
                        isSelected={ isSelected }
                        onClick={ () => toggleAction() }
                      />
                    </div>
                  </div>
                  <div className="recommended-comments__row__right-side">
                    <div className="recommended-comments__row__right-side__winning-losing"/>
                    <div>
                      <div className="recommended-comments__row__right-side__timer">
                        <div className="coupon-row__market-date">{ matchDateDisplay }</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Button title={ 'HEMEN OYNA' } className='btn--primary btn--half-round' onClick={ onSecondaryButtonClick }>
              <span> { `${EnvironmentManager.getMessageText({ key: 'button_betslip_play' }) || 'HEMEN OYNA'} - ${(recommendedCouponDetail?.cost)} TL` }</span>
            </Button>
          </div>
        }
        {
          <div className="wrapInfoText">
            <Icon iconName="svgInfoWarningWhite"/>
            <span> { disclamerMsg }
            </span>
          </div>
        }
        <div className="wrapper_icon__withtext">
          <Icon iconName="svgTribunGreen"/> <span> { `${name}  Tebrikler! Tribün’de Paylaştın.` }</span>
        </div>
      </>
    </div>
  );
};

TribunRouteRecommendedModal.propTypes = {
  onSecondaryButtonClick: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  couponDetails: PropTypes.array.isRequired,
  playCouponState: PropTypes.object.isRequired
};

export default TribunRouteRecommendedModal;
